module.exports = __webpack_public_path__ + "media/images/pillar_fundamentals-79f9fac741a305aabbee552db9e708f1.jpg";